import React, {useRef} from "react";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../ListItemContextMenu/ListItemContextMenu";

interface LinkContextMenuProps {
    className: string;
    href?: string;
    download?: string;
    onOpen?: () => void;
    newWindowUrl: string;
    children: React.ReactNode;
}

export function LinkContextMenu({className, href, download, onOpen, newWindowUrl, children}: LinkContextMenuProps) {
    const menu = useListContextMenu();
    const anchorRef = useRef<HTMLAnchorElement>(null);
    const contextMenuHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        menu.onContextMenu(newWindowUrl, event.clientX, event.clientY);
    };
    const open = () => {
        if (href) {
            anchorRef.current?.click();
        } else if (onOpen) {
            onOpen();
        }
    };
    return (
        <>
            <a className={className} href={href} download={download}
               target={href ? "_blank" : undefined}
               rel={href ? "noopener noreferrer" : undefined}
               ref={anchorRef}
               onClick={href ? undefined : (event) => {
                   event.preventDefault();
                   onOpen?.();
               }}
               onContextMenu={contextMenuHandler}>
                {children}
            </a>
            <ListItemContextMenu menuProps={menu.menuProps} anchorPoint={menu.anchorPoint}
                                 onClose={menu.close} onOpen={open}
                                 onOpenInNewTab={() => openInNewTab(newWindowUrl)}
                                 newTabLabelKey="open_in_new_window"/>
        </>
    );
}
